import "./styles.css";
import { Box } from "@mui/material";

const InfoCards = ({ icon, info, value }) => {
  const getValueClassName = (value) => {
    switch (value) {
      case "CWPM":
        return "cwpm";
      case "Words Read Aloud":
        return "wordsaloud";
      case "Accuracy":
        return "accuracy";
      default:
        return "";
    }
  };

  const getValueParts = (value) => {
    const [part1, part2] = value.split("/");

    return (
      <Box>
        <span className="valuePart1">{part1}</span>
        {part2 ? <span className="valueSlash">/</span> : null}
        {part2 ? <span className="valuePart2">{part2}</span> : null}
      </Box>
    );
  };
  return (
    <Box className="infoCard">
      <Box className="cardPart1">
        <Box className="card-icon">
          <img src={icon} alt={info} />
        </Box>
        <Box className="card-info">{info}</Box>
      </Box>
      <Box className={`card-value ${getValueClassName(info)}`}>
        {getValueParts(value)}
      </Box>
    </Box>
  );
};

export default InfoCards;
